import { LazyAPIImage } from '@components/common/image'
import { CompetititonsListType } from '@lib/types/competitions'
import { t, Trans } from '@lingui/macro'
import { NextPage } from 'next'
import { useRouter } from 'next/router'
import { CompetitionTimer } from './competition-timer'

type Props = {
  competitionList: CompetititonsListType
  slug: string
}

const RecommendedCompetitions: NextPage<Props> = ({
  competitionList,
  slug,
}: Props) => {
  const router = useRouter()
  return (
    <div className="bg-blue-100 bg-opacity-25">
      <div className="mt-20 flex flex-col text-grey container justify-center pt-10 mx-auto px-5 md:py-10 md:px-10">
        <h2 className="text-xl md:text-3xl font-700 mb-12">
          <Trans>Recommended competitions for you</Trans>
        </h2>
        <div className="flex flex-wrap justify-around gap-4">
          {competitionList
            .filter((data) => data.slug != slug)
            .map((data, index) => (
              <>
                {index < 2 && (
                  <div
                    key={index}
                    onClick={() =>
                      router.push({
                        pathname: `/competitions/${data.slug}/`,
                        query: router.query,
                      })
                    }
                    className="shadow-md hover:shadow-xl duration-500 w-80 mb-8 bg-white p-5 cursor-pointer"
                  >
                    <LazyAPIImage
                      className="mb-3 object-contain w-24 p-1 h-24 bg-white border rounded text-grey-500 lg:self-center"
                      src={data.organizer.logo}
                      alt={t`Event Image`}
                    />

                    <h3 className="my-2 font-700">{data.title}</h3>
                    <p className="text-sm font-600 my-2">
                      <Trans>Hosted by: {data.organizer.title}</Trans>
                    </p>
                    <p className="font-600 md:mx-0">
                      <Trans>
                        Ends in:
                        <CompetitionTimer endTime={data.end} />
                      </Trans>
                    </p>
                    <p className="font-600 md:mx-0">
                      <Trans>
                        Team size:
                        <span className="ml-2">{t`1 member`}</span>
                      </Trans>
                    </p>
                    {data.minGrade && data.maxGrade && (
                      <div className="font-600 md:mx-0">
                        <Trans>
                          Grade:
                          <span className="ml-2">
                            {data.minGrade.split(' ')[1]}-
                            {data.maxGrade.split(' ')[1]}
                          </span>
                        </Trans>
                      </div>
                    )}
                  </div>
                )}
              </>
            ))}
        </div>
      </div>
    </div>
  )
}

export default RecommendedCompetitions
